import { render } from "./MerchantStoreForm.vue?vue&type=template&id=04f583a2&scoped=true&ts=true"
import script from "./MerchantStoreForm.vue?vue&type=script&lang=ts"
export * from "./MerchantStoreForm.vue?vue&type=script&lang=ts"

import "./MerchantStoreForm.vue?vue&type=style&index=0&id=04f583a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04f583a2"]])

export default __exports__